// extracted by mini-css-extract-plugin
export default {"container":"Box-container___q686J","container_is_blank":"Box-container_is_blank___JX4GH","container_is_outlined":"Box-container_is_outlined___Rph4H"};